import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 * 课程列表
 * 
*/

export const courseList = () => Http.get(`${baseUrl}/course`)
